import React, { Component } from 'react';
import A from '../Anchor/Anchor';
import { FiMinus, FiPlus } from 'react-icons/fi';

import './CartQuantity.scss';

class CartQuantity extends Component {
  render() {
    const {
      productName,
      value,
      onIncrement,
      onDecrement,
      primaryColor,
      availableLessThanRequested,
      isBig = false,
      isInverse = false,
      disabled,
      style = {},
    } = this.props;

    const minusDisabled = value === 1 || disabled;
    const plusDisabled = value === 99 || disabled;

    return (
      <div className={`quantity ${isBig ? 'big' : ''}`} style={{ ...style }}>
        <A
          href="#"
          aria-label={
            !!productName
              ? `Rimuovi 1 pezzo di ${productName} dal carello`
              : `Rimuovi 1 pezzo dal carello`
          }
          onClick={onDecrement}
          className={`minus ${minusDisabled ? 'btn-outline' : 'btn-primary'}`}
          style={{
            backgroundColor: isInverse ? '#fff' : 'primaryColor',
            color: isInverse || minusDisabled ? primaryColor : '#fff',
            opacity: disabled ? 0.2 : 1,
            cursor: disabled ? 'not-allowed' : 'pointer',
            borderRadius: '10px 0px 0px 10px',
          }}
        >
          <FiMinus />
        </A>

        <span
          className={`value ${
            availableLessThanRequested ? 'not-available' : ''
          }`}
        >
          {value}
        </span>

        <A
          href="#"
          aria-label={
            !!productName
              ? `Aggiungi 1 pezzo di ${productName} al carello`
              : `Aggiungi 1 pezzo al carello`
          }
          onClick={onIncrement}
          className={`plus ${plusDisabled ? 'btn-outline' : 'btn-primary'}`}
          style={{
            backgroundColor: isInverse ? '#fff' : 'primaryColor',
            color: isInverse || plusDisabled ? primaryColor : '#fff',
            opacity: disabled ? 0.2 : 1,
            cursor: disabled ? 'not-allowed' : 'pointer',
            borderRadius: '0px 10px 10px 0px',
          }}
        >
          <FiPlus />
        </A>
      </div>
    );
  }
}

export default CartQuantity;
